import { loadTranslation } from 'server/shared/helpers/translations/translations';
import {
  InpoolLanguage,
  inpoolLanguages,
} from 'server/shared/models/InpoolLanguage';

function getBrowserInpoolLanguage(): InpoolLanguage | undefined {
  return inpoolLanguages.find(
    (language) => language === navigator.language.slice(0, 2),
  );
}

function getStorageInpoolLanguage(): InpoolLanguage | undefined {
  return inpoolLanguages.find(
    (lang) => lang === localStorage.getItem('locale'),
  );
}

export function getLanguage(): InpoolLanguage {
  return getStorageInpoolLanguage() || getBrowserInpoolLanguage() || 'de';
}

function getNestedValue(obj: Record<string, unknown>, path: string): unknown {
  return path
    .split('.')
    .reduce((o: unknown, k) => (o as Record<string, unknown>)?.[k], obj);
}

export function i18nPipeTransform(
  translationKey: string | undefined | null,
  replaceVariables?: { [key: string]: string | undefined | null | number },
): string {
  if (translationKey == null) {
    return '';
  }
  const locale = getLanguage();
  const translation = loadTranslation(locale) as Record<string, unknown>;
  const value =
    translation[translationKey] ?? getNestedValue(translation, translationKey);
  let newText = (typeof value === 'string' ? value : null) ?? translationKey;
  if (replaceVariables) {
    for (const [key, val] of Object.entries(replaceVariables)) {
      if (val !== undefined && val !== null) {
        newText = newText?.replace(`{{${key}}}`, val.toString());
      }
    }
  }
  return newText || '';
}

export function replaceTranslationVariables(
  template: string | undefined | null,
  replaceVariables?: { [key: string]: string | undefined | null | number },
): string {
  if (template == null) {
    return '';
  }
  let result = template;
  if (replaceVariables) {
    for (const [key, val] of Object.entries(replaceVariables)) {
      if (val !== undefined && val !== null) {
        result = result.replace(`{{${key}}}`, val.toString());
      }
    }
  }
  return result || '';
}
